import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

const releaseYear = new Date().getFullYear();

const FooterRoot = styled('footer', {
  name: 'Error',
  slot: 'Root'
})({
  padding: '0 20px',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  '& span': {
    fontSize: 14
  }
});

const Footer = () => (
  <FooterRoot>
    <span
      aria-label="goat"
      role="img"
    >
      🐐
    </span>
    <Text
      align="right"
      color="textSecondary"
      size="sm"
    >
      {`ZenBusiness PBC © ${releaseYear} All Rights Reserved.`}
    </Text>
  </FooterRoot>
);

export default Footer;
